module.exports = "/images/wrongTradeWithOutRed.svg";